import React from 'react';
import { Button } from 'semantic-ui-react';
import log from '../logger';
const MenuButton = props => {
  const {
    /* onKeyDown, */debug,
    ...rest
  } = props;
  if (debug) log.trace('props:', props);
  return /*#__PURE__*/React.createElement(Button, Object.assign({}, rest, {
    onKeyPress: e => {
      // log.trace('key press heard');
      if (e.key === 'Enter' || e.key === ' ') {
        /* Prevent the default action to stop scrolling when space is pressed */
        e.preventDefault();
        e.target.click();
      }
    }
    // onKeyDown={(e) => {
    //     log.trace('onKeyDown...');
    //     if (onKeyDown) onKeyDown(e);
    // }}
  }));
};
export default MenuButton;